import React from 'react'

function Internship() {
   return (
     <>
       <div>
         <div className="flex flex-col  items-start sm:px-16 px-6">
           <h1 className="text-[1.9rem] font-bold tracking-wide ">
             Internships, freelancing and more: ways to earn some extra bucks as
             a student
           </h1>
           <ol
             className="text-md text-[#7D7D7D] tracking-wide pt-3 flex flex-col gap-4 pb-5"
             type="1"
           >
             <li>
               It is no secret that everything around us is becoming more
               expensive each day. The brunt of the rising prices for
               transportation, groceries and rent is being faced by all but
               especially students who have moved out of their homes to pursue
               their higher education. While being ‘broke’ as a student has been
               a subtle norm for generations, it should also be taken into
               consideration that in this day and age we have unlimited access
               to resources which were not available a few years back. So if you
               are not making the most of the unlimited WiFi access at your
               student flats in Delhi or the cafe near your place, you are,
               without a doubt missing out on earning a few extra bucks every
               month.
             </li>
           </ol>
         </div>

         <div className="flex flex-col  items-start sm:px-16 px-6">
           <h1 className="text-[1.5rem] tracking-wide font-semibold">
             Paid Internship
           </h1>
           <ol className="text-sm text-[#7D7D7D] tracking-wide pt-3 flex flex-col gap-4 pb-5">
             <li>
               Internships are a great way to know about your interests and at
               the same time earn money. Even educational institutions
               themselves help students get summer internships relevant to their
               field of interest and study. You can hop on websites such as
               Internshala to search for internships and if you don’t wish to
               travel, you can always opt for the remote options available
               there. Several companies look forward to hiring freshers and
               college students and even pay them well. The most remarkable
               bonus of a paid internship is that it adds value to your CV.
             </li>
           </ol>
         </div>

         <div className="flex flex-col  items-start sm:px-16 px-6">
           <h1 className="text-[1.5rem] tracking-wide font-semibold ">
             Freelancing:
           </h1>
           <ol className="text-sm text-[#7D7D7D] tracking-wide pt-3 flex flex-col gap-4 pb-5">
             <li>
               An option that offers you flexibility, freelancing is a
               relatively easy method to earn money. You select the time and
               days you want to work so that it doesn’t hamper your college
               routine either. The easiest way to start your freelancing journey
               is by creating a dedicated account on platforms such as Fiverr.
               Freelancing is a great way to build your creative portfolio too. 
             </li>
           </ol>
         </div>

         <div className="flex flex-col  items-start sm:px-16 px-6">
           <h1 className="text-[1.5rem] tracking-wide font-semibold ">
             Try Content Writing:
           </h1>
           <ol className="text-sm text-[#7D7D7D] tracking-wide pt-3 flex flex-col gap-4 pb-5">
             <li>
               If you are a marketing student, then you might surely have heard
               the phrase - “content is king”. Today every business is present
               on the internet and the demand for content is not slowing down
               anytime soon. If you can pen down articles, blogs, and listicles
               or proofread quickly and at the same time maintain quality, you
               will find plenty of content writing opportunities some of which
               pay per word and have hefty requirements. The more you write, the
               better you will get!
             </li>
           </ol>
         </div>

         <div className="flex flex-col  items-start sm:px-16 px-6">
           <h1 className="text-[1.5rem] tracking-wide font-semibold ">
             Data Entry Jobs:
           </h1>
           <ol className="text-sm text-[#7D7D7D] tracking-wide pt-3 flex flex-col gap-4 pb-5">
             <li>
               This part-time job is an easy one present in the market and
               doesn’t require too many technical skills besides basic knowledge
               of computers and Microsoft Office. The learning at this stint
               won’t be too high, but it is a good opportunity to learn Excel
               and other Office tools that can help you further down in your
               career. Additionally, this job is easy to find and pays you
               enough for a few hours that you might invest in it.
             </li>
           </ol>
         </div>

         <div className="flex flex-col  items-start sm:px-16 px-6">
           <h1 className="text-[1.5rem] tracking-wide font-semibold">
             Social Media Designer:
           </h1>
           <ol className="text-sm text-[#7D7D7D] tracking-wide pt-3 flex flex-col gap-4 pb-10">
             <li>
               If creating posts online or designing interests you, then you can
               easily start your journey as a graphic designer. While graphic
               designers have more technical skills, you as a social media can
               start by creating social media posts for Instagram, Facebook or
               LinkedIn for small businesses. You can simply use free tools such
               as Canva to create the posts and once you get the hang of it, you
               can move on to more professional software such as Adobe
               Photoshop. Besides designing posts, you can also try your hand at
               writing captions that go along with them. 
             </li>
           </ol>
         </div>
       </div>
     </>
   );
}

export default Internship
